import { render, staticRenderFns } from "./DownloadMaterialForm.vue?vue&type=template&id=6e04483d&"
import script from "./DownloadMaterialForm.vue?vue&type=script&lang=js&"
export * from "./DownloadMaterialForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports